import { changeFilter } from "app/store/dashboard/transmission_analytic/slice/transmissionAnalyticSlice";
import DateRangeFilter from "components/common/filters/daterange/DateRangeFilter";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DATE_FORMAT } from "static/date";
import { getFormattedDate } from "utils/date";

const TransmissionAnalyticDateFilter = () => {
  const { startDate, endDate } = useSelector(
    (state) => state.transmissionAnalytic
  );
  const dispatch = useDispatch();

  return (
    <DateRangeFilter
      startDate={startDate}
      endDate={endDate}
      handleStartDate={(date) => {
        dispatch(
          changeFilter({
            type: "startDate",
            value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
          })
        );
      }}
      handleEndDate={(date) => {
        dispatch(
          changeFilter({
            type: "endDate",
            value: getFormattedDate(date, DATE_FORMAT.ISO_YYYYMMDD),
          })
        );
      }}
    />
  );
};

export default TransmissionAnalyticDateFilter;
